export function roundToTwo(value: number): number {
  const result = round(value, 2);
  return Number(result);
}

export function roundToOne(value: number): number {
  const result = round(value, 1);
  return Number(result);
}

function round(value: number, precision: number): number {
  const multiplier = Math.pow(10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
}
